import { AgeGenderDialogStep } from '@/components/age-and-gender/dialog';
import dynamic from 'next/dynamic';
import { createContext, PropsWithChildren, useCallback, useState } from 'react';

const AgeGenderDialog = dynamic(() =>
    import('@/components/age-and-gender/dialog').then((m) => m.AgeGenderDialog)
);

export interface AgeGenderDialogState {
    isOpen: boolean;
    currentStep: AgeGenderDialogStep;
    setOpenStep: (step?: AgeGenderDialogStep | null) => void;
}

export const AgeGenderDialogContext = createContext<AgeGenderDialogState>(
    null!
);

export const AgeGenderDialogProvider = ({ children }: PropsWithChildren) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentStep, setCurrentStep] = useState<AgeGenderDialogStep>(
        AgeGenderDialogStep.AgeGender
    );

    const setOpenStep = useCallback((step?: AgeGenderDialogStep | null) => {
        if (!step) {
            setIsOpen(false);
        } else {
            setCurrentStep(step);
            setIsOpen(true);
        }
    }, []);

    const handleClose = useCallback(
        () => setOpenStep(undefined),
        [setOpenStep]
    );

    return (
        <>
            <AgeGenderDialogContext.Provider
                value={{ isOpen, currentStep, setOpenStep }}
            >
                {children}
            </AgeGenderDialogContext.Provider>
            {isOpen && (
                <AgeGenderDialog
                    isOpen={isOpen}
                    onClose={handleClose}
                    currentStep={currentStep}
                />
            )}
        </>
    );
};

export default AgeGenderDialogProvider;
export { AgeGenderDialogStep } from '@/components/age-and-gender/dialog';
